import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";

export function initproductsSectionsEffects() {
    const tabletWidth = 1000;
    const productsSection = $('.products');
    const title = $('.products .heading');
    const product = $('.products .product-item');
    const productDesc = $('.products .product-description');
    const productLink = $('.products .arrow-link');


    function showImages(largePhoto, smallPhoto) {
        const LargeImageBias = {
            plus: '-60%',
            minus: '30%',
        }
        const smallImageBias = {
            plus: '-55%',
            minus: '60%'
        }

        function initAnimation({
                                   image,
                                   percents,
                                   startBias = 'top',
                                   endBias = 'bottom'
                               }) {
            const imageInner = image.find('.photo-inner');

            gsap.timeline({
                scrollTrigger: {
                    trigger: image,
                    start: `${startBias} bottom`,
                    end: `${endBias} top`,
                    scrub: true,
                    invalidateOnResize: true,
                },
            }).from(imageInner, {
                y: percents.plus,
            }).to(imageInner, {
                y: percents.minus,
            });
        }

        initAnimation({
            image: largePhoto,
            percents: LargeImageBias,
            endBias:'bottom+=50%'
        });
        initAnimation(
            {
                image: smallPhoto,
                percents: smallImageBias,
                endBias:'bottom+=80%'
            });
    }

    function showElement(
        item,
        {
            opacity,
            x,
            y,
            scaleY,
            delay,
            duration = 0.5
        }
    ) {
        gsap.set(item, {opacity, x, y, scaleY, delay, duration});

        ScrollTrigger.batch(item, {
            onEnter: batch => {
                gsap.to(batch, {opacity: 1, x: 0, y: 0, scaleY: 1, delay, duration, stagger: {each: 0.15}})
            },
            onLeaveBack: batch => {
                gsap.to(batch, {opacity, x: -x / 2, y: -y / 2, scaleY, delay, duration, stagger: {each: 0.15}})
            }
        });
    }

    function showLink(
        item,
        {
            opacity,
            x,
            y,
        }) {

        gsap.set(item, {opacity, x, y});

        ScrollTrigger.create({
            trigger: item,
            start: "top+=100 bottom",
            onEnter: () => {
                gsap.to(item, {opacity: 1, x: 0, y: 0});
            },
            onLeaveBack: () => {
                gsap.to(item, {opacity, x, y});
            }
        });
    }

    if (title.length) showElement(title, {opacity: 0, y: 200});
    showElement(product, {opacity: 0, y: 200});
    showElement(productDesc, {opacity: 0, y: 200});

    if ($(window).width() <= tabletWidth) {
        showElement(productLink, {opacity: 0, y: 150});
    }
    if ($(window).width() > tabletWidth) {
        productLink.each( (i,elem) => {
            showLink(elem, {opacity: 0, x: '-40%'});
        });
    }

    productsSection.each( (i,section) => {
        const largeImg = $(section).find('.large.photo');
        const smallImg = $(section).find('.small.photo');

        if (!largeImg.length & !smallImg.length) return;

        showImages(largeImg, smallImg);
    });
}
